import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {industriesRegister} from "../../services/industriesRegister";
import {scraperRegister} from "../../services/scraperRegister";
import Typist from "react-typist";
import BoosterHeader from "../../components/booster-header/component";
import queryString from "query-string";
import Carousel from 're-carousel';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import BoosterProperty from "../../components/booster-property/component";
import Footer from "../../components/footer/component";
import {scroller, Element} from 'react-scroll'
import * as moment from 'moment'
import DropdownTabs from "../../components/dropdown-tabs/component";
import CompareSellWithUs from "../../components/compare-sell-with-us/component";
import FaqSellWithUs from "../../components/faq-sell-with-us/component";
import DropdownSliderPrice from "../../components/dropdown-slider-price/component";
import Dropdown from "../../components/dropdown/component";
import YieldlockCalculatorSellToStay from "../../components/yieldlock-calculator-sell-to-stay/component";
import YieldlockCalculator from "../../components/yieldlock-calculator/component";
import YieldlockCalculatorSellToLet from "../../components/yieldlock-calculator-sell-to-let/component";
import CompareBuyWithUs from "../../components/compare-buy-with-us/component";
import FaqBuyWithUs from "../../components/faq-buy-with-us/component";

class BuyWithUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tab: {id: 1, title: "i want to sell-to-stay"},
            annual_rent: 0,
            confirmed_offer: 0,
            locking_years: {
                options: [
                    {id: 3, title: '3 Years', years: 3},
                    {id: 4, title: '4 Years', years: 4},
                    {id: 5, title: '5 Years', years: 5},
                    {id: 6, title: '6 Years', years: 6},
                    {id: 7, title: '7 Years', years: 7}
                ],
                placeholder: "Set term",
                value: JSON.stringify({id: 5, title: '5 Years'}),
                error: false
            },
            locking_yield: {
                options: [
                    {id: 3, title: '3% Yield', yield: 3},
                    {id: 4, title: '4% Yield', yield: 4},
                    {id: 5, title: '5% Yield', yield: 5},
                    {id: 6, title: '6% Yield', yield: 6},
                    {id: 7, title: '7% Yield', yield: 7}
                ],
                placeholder: "Select yield",
                value: '-1',
                error: false
            },
            types: {
                options: [
                    {id: 0, title: 'Sell-to-stay'},
                    {id: 1, title: 'Sell-to-let'}
                ],
                placeholder: "Set term",
                value: JSON.stringify({id: 0, title: 'Sell-to-stay'}),
                error: false
            },
            short_term: {
                options: [
                    {id: 0, title: 'Short-term eligible'},
                    {id: 1, title: 'Short-term not eligible'}
                ],
                placeholder: "Set eligibility",
                value: JSON.stringify({id: 0, title: 'Short-term eligible'}),
                error: false
            },
            init_yield: 3
        };
    };

    componentWillMount() {

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/buy');
            ReactGA4.send({ hitType: "pageview", page: "/buy" });
        }

    }

    functions = {};

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad() {
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldlock() {
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldspotter() {
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        } catch (e) {
            return false
        }
    }

    renderDropdownValue(item) {
        try {
            return JSON.parse(item).id;
        } catch (e) {
        }
    }

    valid() {
        return this.state.types.value !== "-1" && this.state.locking_years.value !== "-1" && this.state.annual_rent > 0 && this.state.confirmed_offer > 0
    }

    render() {
        return (
            <div className={Styles.background}>
                <Element name="top" className="top"></Element>
                <BoosterHeader lang={this.props.match.params.lang} market={this.props.match.params.market}
                               history={this.props.history}/>
                <div className={Styles.container}>
                    <div className={Styles.header}>
                        <div className={Styles.headerTitle}>
                            Buy your on-plan <span className={Styles.headerTitleBold}>with real yield</span>
                        </div>
                        <div className={Styles.headerSubtitle}>
                            ”up to 7 years real yield banked up-front” ★★★★★
                        </div>
                    </div>
                    <div className={Styles.containerInner}>
                        <div className={Styles.tabs}>
                        </div>
                        {
                            <div className={Styles.tabsInfo}>
                                <div className={Styles.tabsInfoLeft}>
                                    <img className={Styles.tabsInfoLeftBackground}
                                         src={require("../../assets/images/YS_halo.png")}/>
                                    <img src={require('../../assets/images/YS_aplusassured_Trans_EN.png')}
                                         className={Styles.tabsInfoLeftImage}/>
                                </div>
                                <div className={Styles.tabsInfoRight}>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>REAL YIELD ASSURED UP TO 7 YEARS</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>assured future payouts and solvency
                                        </div>
                                    </div>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>ALL YIELD BANKED UP-FRONT</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>A+ grade deposit
                                        </div>
                                    </div>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>NO ADMINISTRATION</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>all management included
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={Styles.tableInfo}>
                            <CompareBuyWithUs
                                tab={this.state.tab}
                            />
                        </div>
                        <div className={Styles.contactAgent}>
                            <div className={Styles.contactAgentTitle}>
                                <div>
                                    Connect me to an <span className={Styles.contactAgentTitleBold}>agent...</span>
                                </div>
                                <div className={Styles.contactAgentSpace}></div>
                                <div className={Styles.contactAgentIcons}>
                                    <a href={"tel:" + "+971550000000"}>
                                    <div className={Styles.contactAgentIcon}>
                                        <img className={Styles.contactAgentIconPhone}
                                             src={require("../../assets/images/phone_icon_white.png")}/>
                                    </div>
                                    </a>
                                    <a href={"https://wa.me/" + "+971550000000" + "/?text=" + "Hey"}>
                                    <div className={Styles.contactAgentIcon}>
                                        <img className={Styles.contactAgentIconWhatsApp}
                                             src={require("../../assets/images/whatsapp_white.png")}/>
                                    </div>
                                    </a>
                                </div>
                            </div>
                            <div className={Styles.contactAgentInputs}>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"First name*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"Last name*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"Email*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"Mobile*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                            </div>
                            <div className={Styles.contactAgentButton}>
                                get pre-approved
                            </div>
                        </div>
                        <div className={Styles.howDoesItWork}>
                            How does<span className={Styles.howDoesItWorkBold}>{" "}it work</span>
                        </div>
                        <div className={Styles.howDoesItWorkItems}>
                            <div className={Styles.howDoesItWorkItemsLeft}>
                                <div className={Styles.howDoesItWorkItemsLeftNumber}>
                                    1
                                </div>
                                <div className={Styles.howDoesItWorkItemsLeftContent}>
                                    <div className={Styles.howDoesItWorkItemsLeftContentTitle}>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                            SPOT A VERIFIED YIELD DEAL
                                        </div>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleSpace}/>
                                    </div>
                                    <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                        Chose your property and yield plan.
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.howDoesItWorkItemsRight}>
                                <div className={Styles.howDoesItWorkItemsRightNumber}>
                                    2
                                </div>
                                <div className={Styles.howDoesItWorkItemsLeftContent}>
                                    <div className={Styles.howDoesItWorkItemsLeftContentTitle}>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                            CONNECT WITH A CERTIFIED AGENT
                                        </div>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleSpace}/>
                                    </div>
                                    <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                        Get a dedicated agent all the way.
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.howDoesItWorkItemsLeft}>
                                <div className={Styles.howDoesItWorkItemsLeftNumber}>
                                    3
                                </div>
                                <div className={Styles.howDoesItWorkItemsLeftContent}>
                                    <div className={Styles.howDoesItWorkItemsLeftContentTitle}>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                            START GETTING YIELD AFTER TRANSFER
                                        </div>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleSpace}/>
                                    </div>
                                    <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                        All yield in the bank from day 1.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={Styles.faqTitle}>
                            Any{" "}<span className={Styles.faqTitleBold}>questions?</span>
                        </div>
                        <div className={Styles.faqItems}>
                            <FaqBuyWithUs lang={this.props.match.params.lang} tab={this.state.tab}/>
                        </div>
                    </div>
                </div>
                <div className={Styles.footer}>
                    <div className={Styles.footerInner}>
                        <div className={Styles.footerInnerItems}>
                            <div className={Styles.footerQuote}>
                                ”Finally a high yielding low-risk alternative to off-plan” ★★★★★
                            </div>
                            <img className={Styles.footerBadge} src={require("../../assets/images/YS_badgeInnovator.png")}/>
                        </div>
                    </div>
                    <img className={Styles.footerImageDesktop} src={require("../../assets/images/YS_skyline_Desktop_AE_B1_v2.jpg")}/>
                    <img className={Styles.footerImageMobile} src={require("../../assets/images/YS_skyline_Mobile_AE_B1_v2.jpg")}/>
                </div>
            </div>
        );
    }
}

export default BuyWithUs;


// WEBPACK FOOTER //
// ./src/pages/buy-with-us/component.js